var React = require('react');

function CloseHamburgerInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M23.1123 23.1421L2.97015 2.99993","stroke":"#2B72F5","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M3.17285 23.1421L23.315 2.99993","stroke":"#2B72F5","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CloseHamburgerInline.defaultProps = {"width":"27","height":"26","viewBox":"0 0 27 26","fill":"none"};

module.exports = CloseHamburgerInline;

CloseHamburgerInline.default = CloseHamburgerInline;
